import React, {useState, useEffect} from 'react'
import { Row, Container, Form } from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import {getAmazonBooks, getCheggBooks} from '../../actions/book';
import { useDispatch, useSelector } from 'react-redux';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Background from './web.png';
import {Link} from 'react-router-dom';
import {GrAmazon} from 'react-icons/gr';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import {Col} from 'react-bootstrap';
import Navbar from '../Common/Navbar';
import Closing from '../Common/Closing';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  table: {
    minWidth: 600,
},
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#203354',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#a5c9f2',
    },
  },
}))(TableRow);


const pageList = ["Chegg", "AbeBooks", "CampusBooks", "ThriftBooks", "Bookfinder", "TextBookRush"]

const Web = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();

    const [search, setSearch] = useState('');
    const [message, setMessage] = useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(3);
    const [state, setState] = React.useState({
      checkedA: true,
      checkedB: false
    });
    
    let results = useSelector((state) => state.webbooks);
    const ownerInfo = localStorage.getItem('profile')
  
    const handleChangePage = (event, newPage) => {
     setPage(newPage);
    };
    
    const goToHomepage = () => {
      history.push('/')
    }
    
    const handleChangeRowsPerPage = (event) => {
      
    };
    
    const searchChange = (e) =>{
      setSearch(e.target.value)  
    }
    
    const handleSubmit = (event) =>{
      event.preventDefault();
      dispatch(getAmazonBooks(search));
      history.push('/web')
      setMessage('Fetching data from the web!')
    }

    const handleChange = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
    };
    
    
    return (
        <div>
          {!ownerInfo && goToHomepage()}
          <Navbar />
          < br />
          <Container fluid="md">
            <Row>
              <form onSubmit = {handleSubmit}>
                <Form.Group>
                  <Form.Control onChange = {searchChange} value = {search} size="lg" type="text" placeholder="Search for the books by their title and author name (Eg. Linear Algebra)" />
                </Form.Group>
              </form>
            </Row>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={state.checkedA}
                    onChange={handleChange}
                    name="checkedA" 
                    color="primary"
                  />
                }
                label="Amazon"
              />
              <OverlayTrigger
                key={"bottom"}
                placement={"bottom"}
                overlay={
                  <Tooltip id={`tooltip-bottom`}>
                    Features under construction.
                  </Tooltip>
                }
              >    
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="Chegg"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="AbeBooks"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="CampusBooks"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="ThriftBooks"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="Bookfinder"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={state.checkedB}
                        name="checkedA"
                        color="primary"
                      />
                    }
                    disabled
                    label="TextBookRush"
                  />
                </div>  
              </OverlayTrigger>
            </FormGroup>
          </Container>
          {!state.checkedA || !results.length ? 
            <div>
              <React.Fragment>
                <CssBaseline />
                <Container>
                  <Typography component="div" style={{backgroundImage: `url(${Background})`, backgroundPosition: "center",  height: '75vh'}} >
                    <br />
                    {state.checkedA ? 
                      <h3> {message} <h2> {'    '} {message && <CircularProgress />}  </h2></h3>:  <> <h3>Please select one of the websites!</h3> </> 
                    }
                  </Typography>
                </Container>
              </React.Fragment>
            </div>
          : 
            <>
              <br />
              <Container>
                <Row>
                  <Col sm={12}>
                    <Paper className={classes.root}>
                      <TableContainer className = {classes.container}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>Image</StyledTableCell>
                              <StyledTableCell align = "left">Book Name</StyledTableCell>
                              <StyledTableCell align = "right">Rating</StyledTableCell>
                              <StyledTableCell align = "right">Quantity</StyledTableCell>
                              <StyledTableCell align = "right">Price(s)</StyledTableCell>
                              <StyledTableCell >Visit</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {results.slice(page * 7, page * 7 + 7).map((result) => (
                              <StyledTableRow >  
                                <StyledTableCell component="th" scope="row">
                                  <OverlayTrigger
                                    key={"bottom"}
                                    placement={"right"}
                                    overlay={
                                      <Tooltip id={`tooltip-right`}>
                                        <img src={result.image} width="180" height="320" />
                                      </Tooltip>
                                    }
                                  >
                                    <img src={result.image} width="40" height="60" />
                                  </OverlayTrigger>
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  {result.name}                       
                                </StyledTableCell>
                                < StyledTableCell align="right">
                                  {result.stars ? result.stars : <> N/A </>}
                                </StyledTableCell>
                                < StyledTableCell align="right">
                                  {result.availability_quantity ? result.availability_quantity : <> N/A </>}
                                </StyledTableCell>
                                < StyledTableCell align="right">
                                  {result.price_string ?(result.price_string.split('$').slice(1,)).map((price) => <> ${price}&nbsp; </>) : <> N/A </>}
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Link to={{ pathname: `${result.url}` }} target="_blank">
                                    <Button variant="outline-primary">
                                      <GrAmazon /> 
                                    </Button>
                                  </Link>
                                </StyledTableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[7]}
                        component="div"
                        count={results.length}
                        rowsPerPage={7}
                        page={page}
                        onChangePage={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </Col>
                </Row>
              </Container>
            </>
          }
          <Closing />
        </div>
      )
    }

export default Web
